angular.module('Itao.IndicatorMap').directive('labelSelect', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'labelselect.html',
    restrict: 'E',
    scope: {
      optionStates: '=',
      changeTooltip: '&',
      selectedIndicator: '='
    },
    link: function (scope) {
      scope.optionStates = angular.isUndefined(scope.optionStates) ? mapConfig.defaultLabels : scope.optionStates;

      /**
       * Manages the optionStates when a option was clicked/selected
       */
      scope.selectOption = function () {
        scope.changeTooltip();
      };
    }
  };
});
